var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BountyService } from './../../services/bounty.service';
import { OnInit, EventEmitter } from '@angular/core';
var ClaimBountyFormComponent = /** @class */ (function () {
    function ClaimBountyFormComponent(bountyService) {
        this.bountyService = bountyService;
        this.submitting = false;
        this.errors = [];
        this.success = false;
        this.claimCreated = new EventEmitter();
        var user = window.user;
        this.user = user;
        this.isLoggedIn = !!user;
        this.isVerified = user && user.osu_username_verified;
    }
    ClaimBountyFormComponent.prototype.ngOnInit = function () { };
    ClaimBountyFormComponent.prototype.submitClaim = function () {
        return __awaiter(this, void 0, void 0, function () {
            var claim_id, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitting = true;
                        this.errors = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.bountyService.submitClaim(this.bounty.id, this.evidence)];
                    case 2:
                        claim_id = (_a.sent()).claim_id;
                        this.success = true;
                        this.claimCreated.next(claim_id);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1.error) {
                            if (e_1.error.errors) {
                                this.errors = Object.values(e_1.error.errors).reduce(function (acc, curr) {
                                    acc.push.apply(acc, curr);
                                    return acc;
                                }, []);
                            }
                            else if (e_1.error.error) {
                                this.errors = [e_1.error.error];
                            }
                            else {
                                this.errors = ['A server error occured'];
                            }
                        }
                        else {
                            this.errors = ['A server error occured'];
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        this.submitting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return ClaimBountyFormComponent;
}());
export { ClaimBountyFormComponent };
